module.exports = __webpack_public_path__ + "img/38.d6a8d423.png";